import axios from "axios";
import { handleApiError } from "../utils/errorHandler";

export const config = (token: string) => {
  return {
    headers: {
      Authorization: `Bearer ` + token,
    },
  };
};

export const authApi = axios.create({
  baseURL: `${process.env.REACT_APP_Base_URL}`,
});
export const dashboardApi = axios.create({
  baseURL: `${process.env.REACT_APP_Base_URL}`,
});

authApi.interceptors.response.use(null, handleApiError);
dashboardApi.interceptors.response.use(null, handleApiError);
